import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export function AddChecklistDialogButton({
  onSave,
}: {
  onSave?: (name: string) => void
}) {
  const [open, setOpen] = useState(false)
  const [isSaving, setIsSaving] = useState(false)
  const { t } = useTranslation()

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button
          data-test-id="add-checklist-button"
          className="bg-primary text-primary-foreground hover:bg-primary/90"
        >
          {t('checklists.addChecklist')}
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px] rounded-2xl">
        <form
          onSubmit={(e) => {
            e.preventDefault()

            const form = e.target as HTMLFormElement
            const data = new FormData(form)
            const name = data.get('name') as string

            if (name.trim() === '') return

            setIsSaving(true)

            onSave?.(name)

            setOpen(false)
            setIsSaving(false)
          }}
        >
          <DialogHeader>
            <DialogTitle>{t('checklists.addChecklist')}</DialogTitle>
            <DialogDescription>
              {t('checklists.addChecklistDescription')}
            </DialogDescription>
          </DialogHeader>
          <div className="grid gap-4 py-4">
            <div className="grid grid-cols-4 items-center gap-4">
              <Label htmlFor="name" className="text-right">
                {t('checklists.checklistName')}
              </Label>
              <Input
                id="name"
                name="name"
                data-test-id="add-checklist-name"
                className="col-span-3"
                autoComplete="off"
                data-1p-ignore
              />
            </div>
          </div>
          <DialogFooter className="!justify-between">
            <Button
              variant="secondary"
              type="button"
              onClick={() => setOpen(false)}
            >
              {t('cancel')}
            </Button>
            <Button
              disabled={isSaving}
              type="submit"
              data-test-id="add-checklist-submit"
              className="bg-primary text-primary-foreground hover:bg-primary/90"
            >
              {t('checklists.createChecklist')}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  )
}
